export default __webpack_public_path__ + "static/media/logo.b9af0b47.svg";